__turbopack_context__.v({
  "ability": "HeroBoard-module__yebQVq__ability",
  "abilitySpecialty": "HeroBoard-module__yebQVq__abilitySpecialty",
  "block": "HeroBoard-module__yebQVq__block",
  "board": "HeroBoard-module__yebQVq__board",
  "expertEffects": "HeroBoard-module__yebQVq__expertEffects",
  "expertIcon": "HeroBoard-module__yebQVq__expertIcon",
  "fracLevels": "HeroBoard-module__yebQVq__fracLevels",
  "handIcon": "HeroBoard-module__yebQVq__handIcon",
  "handLimit": "HeroBoard-module__yebQVq__handLimit",
  "intLevels": "HeroBoard-module__yebQVq__intLevels",
  "level": "HeroBoard-module__yebQVq__level",
  "levelBoxes": "HeroBoard-module__yebQVq__levelBoxes",
  "levelDirection": "HeroBoard-module__yebQVq__levelDirection",
  "levelDirectionContainer": "HeroBoard-module__yebQVq__levelDirectionContainer",
  "levelEffects": "HeroBoard-module__yebQVq__levelEffects",
  "levelTitles": "HeroBoard-module__yebQVq__levelTitles",
  "magic": "HeroBoard-module__yebQVq__magic",
  "mightMagicIcon": "HeroBoard-module__yebQVq__mightMagicIcon",
  "name": "HeroBoard-module__yebQVq__name",
  "portrait": "HeroBoard-module__yebQVq__portrait",
  "specialty": "HeroBoard-module__yebQVq__specialty",
  "specialtyLevel": "HeroBoard-module__yebQVq__specialtyLevel",
  "stat": "HeroBoard-module__yebQVq__stat",
  "stats": "HeroBoard-module__yebQVq__stats",
});
